import React from "react";
import { useRouter } from "next/router";
import Icon from "@/components/icon";
import css from "./.module.scss";

const LicenseExpiredAlert = ({ listing }) => {
  const router = useRouter();
  const handleClick = () => {
    router.push({
      pathname: "/add-rega-listing/init",
      query: {
        replicateId: listing.id,
        replicateData: JSON.stringify(listing),
      },
    });
  };
  return (
    <div className={css.licenseExpiredAlert}>
      <div className={css.header}>
        <Icon name="error" width={20} height={20} />
        <p className={css.top}>تم إغلاق الإعلان لانتهاء الترخيص!</p>
      </div>
      <p className={css.body}>
        لنشر إعلان جديد بنفس الصور والتفاصيل{" "}
        <span className={css.clickable} onClick={handleClick}>
          اضغط هنا
        </span>
        .
      </p>
    </div>
  );
};

export default LicenseExpiredAlert;
